export default function Fun() {
  return (
    <main
      style={{
        maxWidth: 600,
        margin: "24px auto",
        padding: "0 16px",
        fontFamily: "system-ui, sans-serif",
        color: "#0f172a",
      }}
    >
      <h1
        style={{
          fontSize: 28,
          fontWeight: 600,
          marginTop: 0,
          marginBottom: 12,
        }}
      >
        Fun / Playground 🎉
      </h1>

      <p
        style={{
          fontSize: 14,
          color: "#475569",
          lineHeight: 1.5,
          marginTop: 0,
        }}
      >
        This is your sandbox page. You can test components, ideas, streak
        tracking, reading goals, charts—anything—without breaking Library.
      </p>

      <div
        style={{
          marginTop: 24,
          background: "#fff",
          border: "1px solid #cbd5e1",
          borderRadius: 12,
          padding: 16,
          fontSize: 14,
          lineHeight: 1.4,
          color: "#0f172a",
        }}
      >
        <div style={{ fontWeight: 600, marginBottom: 8 }}>
          Quick ideas you can add here:
        </div>
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Reading streak / pages per day</li>
          <li>“Next up to read” queue</li>
          <li>Quote of the day from a book</li>
        </ul>
      </div>
    </main>
  );
}
